import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Observable, observableOf, rx } from '@app/shared/rx/rx-wrapper';
import { select } from '@angular-redux/store';

@Injectable()
export class TranslationGuard implements CanActivate {
  @select(['userSession', 'i18n', 'translationInitialized'])
  private translationInitialized$: Observable<boolean>;

  /**
   * use this to check if the translation guard has been initialized
   * this is used to prevent multiple initializations of the guard
   */
  public static isInitialized = false;

  public constructor() {}

  public canActivate(): Observable<boolean> {
    if (TranslationGuard.isInitialized) {
      return observableOf(true);
    }

    TranslationGuard.isInitialized = true;

    return this.translationInitialized$.pipe(
      rx.first(),
      rx.switchMap(() => {
        return observableOf(true);
      }),
    );
  }
}
